/* eslint-disable @typescript-eslint/no-misused-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { stringify } from 'hub-http/helpers/params';
import { Flex } from 'foundations-components/components/Flex';
import { PlayerPlayIcon } from 'foundations-assets/icons/components/PlayerPlayIcon';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Button } from 'foundations-components/transitional/components/Button';
import UsageTracker from '../../../../utils/UsageTracker';
import { useRequestLearnWhileDoing } from '../../hooks';
import { SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS } from '../../../../constants/Navigation';
import useNavigate from '../../../../hooks/useNavigate';
import { useShort } from '../../../shortContent/shortContentQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LearnWhileDoingButton = ({
  otgId
}) => {
  const {
    isVideoFinished,
    isVideoPlayed
  } = useRequestLearnWhileDoing();
  const {
    short
  } = useShort(Number(otgId), !otgId);
  const videoType = short === null || short === void 0 ? void 0 : short.type;
  const navigate = useNavigate();
  const learnByDoingOnClick = () => {
    UsageTracker.track('contentInteraction', {
      action: 'learn-by-doing-cta-play-in-software-clicked',
      shortId: String(otgId),
      contentId: String(otgId),
      videoType
    });
    navigate(location => Object.assign({}, location, {
      search: `?${stringify({
        otgId,
        isLearnWhileDoing: true
      })}`,
      pathname: `/${SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS}`
    }));
  };
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "learn-while-doing-button",
    onClick: learnByDoingOnClick,
    size: "medium",
    use: "tertiary-light",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      gap: "200",
      children: [!isVideoFinished && isVideoPlayed ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.learnByDoing.continueInsideHubSpotSoftware"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.learnByDoing.watchInAccount"
      }), /*#__PURE__*/_jsx(IconCircle, {
        backgroundColor: 'fill-accent-orange-default',
        borderWidth: '0',
        color: "fill-surface-default",
        icon: PlayerPlayIcon,
        padding: "100",
        size: '100'
      })]
    })
  });
};
export default LearnWhileDoingButton;